import { Logo } from '../Logo/Logo';
import { Button } from '../buttons/Button/Button';
import goodFace from '../../images/icons/GoodfaceLogo.svg';
import './footer.css';
import RouterLink from 'components/RouterLink';

const Footer = () => {
    return (
        <footer className="container">
            <div className="footer">
                <div className="footer-upper-section">
                    <div>
                        <div className="logo">
                            <Logo />
                        </div>
                        <p className="description-medium">
                            Ensuring safer harvests
                            <br /> in an unsafer environment.
                        </p>
                    </div>
                    <div className="company-data-wrapper">
                        <div className="company-information">
                            <div>
                                <p className="body1">Company</p>
                                <RouterLink pathName="aboutUs">ABOUT US</RouterLink>
                                <RouterLink pathName="news">RESEARCH, NEWS & EVENTS</RouterLink>
                                <RouterLink pathName="career">CAREER</RouterLink>
                                <RouterLink pathName="contacts">CONTACTS</RouterLink>
                            </div>
                            <div>
                                <p className="body1">Products</p>
                                <RouterLink pathName="aboutProduct">ORGANIC LINE</RouterLink>
                                <RouterLink pathName="aboutProduct">WUXAL</RouterLink>
                                <RouterLink pathName="aboutProduct">PERTIPLANT</RouterLink>
                                <RouterLink pathName="aboutProduct">UNIFERX</RouterLink>
                            </div>
                            <div>
                                <p className="body1">Resources</p>
                                <RouterLink pathName="cropNutritionPrograms">CROP NUTRITION PROGRAMS</RouterLink>
                                <RouterLink pathName="trialResults">TRIAL RESULTS</RouterLink>
                                <RouterLink pathName="informationMaterials">INFORMATION MATERIALS</RouterLink>
                            </div>
                        </div>
                        <div className="footer-contacts">
                            <div>
                                <p className="body1">Social media</p>
                                <div>
                                    <Button type="instagram" />
                                    <Button type="facebook" />
                                    <Button type="youtube" />
                                </div>
                            </div>
                            <div>
                                <p className="body1">Contacts</p>
                                <a href="mailto:info@uniferx.com" className="button-text mail">
                                    INFO@UNIFERX.COM
                                </a>
                                <a href="tel:+380443344700" className="button-text phone">
                                    +38 044 33 44 700
                                </a>
                                <a href="/#" className="button-text map-pin">
                                    81 TURGENEVSKA St., KYIV, OFFICE. 1-А
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-lower-section">
                    <p className="body1 copyright">Copyright © UniferX 2023</p>
                    <div className="policies">
                        <RouterLink pathName="termsAndConditions">TERMS & CONDITIONS</RouterLink>
                        <RouterLink pathName="legalInfo">LEGAL INFO</RouterLink>
                        <RouterLink pathName="cookiePolicy">COOKIE POLICY</RouterLink>
                        <RouterLink pathName="anonymousFeedback">ANONYMOUS FEEDBACK</RouterLink>
                    </div>
                    <p className="goodface-bar">
                        <span className="body1">Created by</span>{' '}
                        <span className="goodface">
                            <a href="https://goodface.agency" target="_blank" rel="noreferrer">
                                Goodface
                                <img src={goodFace} alt="Goodface logo" />
                            </a>
                        </span>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
